<div class="execution-wrapper">
  <div id='rootExecution' class="container-tool">
    <h1>Upload your files</h1>
    <div class="currency-wrapper scenarios-wrapper">
      <!-- todo title currency dropdown currency toggle collapse sections for types -->
    </div>
    <div class="execution-container">
      <!-- CONFIGURATION BOX -->
      <div class="configuration configuration-options" *ngIf='configurations?.length'>
        <app-collapsable-wrapper title='Configuration' thHide="HIDE">
          <p class="config-description">{{ tabsConfiguration?.configuration_section_description }}</p>
          <app-configurations-info
            [configurations]='configurations'
            [isTemplateFill]='isTemplateFill'
            [idExecution]='idExecution'
            [execution]='execution'
            (sendSelectedConfigToParent)='getSelectedConfig($event)'
            (sendTemplatesTaxonomyList)='setTemplatesTaxonomyList($event)'
            (sendTemplatesTaxonomyCheck)='setTemplatesTaxonomyCheck($event)'
            (updateSettingsTool)='updateTabsConfig()'
          ></app-configurations-info>
        </app-collapsable-wrapper>
      </div>

      <!-- Buttons that collapse the boxes below -->
      <div class="key-sets-wrapper" *ngIf='selectedKey'>
        <div class="title border-bottom w-100 text-left">Your files</div>
        <p class="set-description">{{ tabsConfiguration?.tab_section_descrition }}</p>
        <div class="tabs-wrapper">
          <div class="tabs-container">
            <a
              *ngFor='let key of keys; let i = index'
              (click)='getSelected(key, i)'
              class="key-sets {{i === activeIndexTab ? 'border-' + execution?.name_tool : '' }}"
            >
              {{getToolName(i + 1)}}
            </a>
          </div>
          <button
            type='button'
            class="btn btn-link ey-btn-link" 
            (click)='(typeExecution === "ESG" || typeExecution === "ESV" ) ? addSetModal() : createNewFund()'
          >
            {{getToolName()}}
          </button>
        </div>
      </div>

      <!-- CONFIGURATION CURRENCY AND SECTION VISIBILITY -->
      <!-- selectedKey !== undefined because in NLL and NLS tool tabs name === "" -->
      <ng-container *ngIf='selectedKey !== undefined'>
        <div class="tab-configurator" [class.open-collapse]="collapsed" *ngIf='selectedKey !== ""'>
          <ng-template #openCollapse>
            <ng-container *ngFor='let tabConfiguration of tabs[selectedKey]?.tab_configuration'>
              <div class="rr w-100" *ngIf='tabConfiguration.name === "Recovery Rate"'>
                <div class="rr-text-normal">{{tabConfiguration.description}}</div>
              </div>
              <div class="config">
                <div class="name-container">
                  <label
                    class="name"
                    [class.text-error]="validationText">
                    {{tabConfiguration.name}} {{tabConfiguration.name === 'Recovery Rate' ? '(optional)' : ''}}
                  </label>
                </div>
                <div class="select-container">
                  <input
                    type="text"
                    class="input-form-control"
                    *ngIf='tabConfiguration.name === "Fund Name"; else recoveryRateInput'
                    [(ngModel)]="tabConfiguration.choosen_value"
                    placeholder='Insert value'
                    (blur)='addTagPromise(tabConfiguration.choosen_value, tabConfiguration.name, selectedKey)'>
                  <ng-template #recoveryRateInput>
                    <ng-container *ngIf='tabConfiguration.name === "Recovery Rate"; else selectCustom'>
                      <input
                      type="text"
                        class="input-form-control"
                        [(ngModel)]="tabConfiguration.choosen_value"
                        placeholder='Insert value'
                        (blur)='addTagPromise(tabConfiguration.choosen_value, tabConfiguration.name, selectedKey, true)'>
                        <small class="rr-text text-error RR-error" *ngIf='validationText'>{{validationText}}</small>
                    </ng-container>
                  </ng-template>
                  <ng-template #selectCustom>
                    <ng-select
                      *ngIf='tabConfiguration.component_type === "select"'
                      class='custom select-check-value'
                      [clearable]="false"
                      bindLabel="value"
                      bindValue="id"
                      [(ngModel)]='tabConfiguration.choosen_value'
                      [searchable]="false"
                      [items]='tabConfiguration.values'
                      placeholder='Select an option'
                      (change)='getSingleTabConfig(tabConfiguration)'
                    >
                    </ng-select>
                      <ng-select
                      *ngIf='tabConfiguration.component_type === "editable_select"'
                      class='custom select-input no-padding select-check-value'
                      [addTag]="addCurrency"
                      [clearable]="false"
                      bindLabel="value"
                      bindValue="id"
                      [(ngModel)]='tabConfiguration.choosen_value'
                      [items]='tabConfiguration.values'
                      placeholder='Select or create an option'
                      (change)='getSingleTabConfig(tabConfiguration)'
                    >
                    </ng-select>
                  </ng-template>
                </div>
              </div>
            </ng-container>
              <!-- SECTION CONFIGURATION  DIFFERENT SET -->
            <div class="config" *ngIf='selectedKey && (typeExecution === "ESG" || typeExecution === "ESV")'>
              <div class="name-container">
                <label class="name">Scenario type</label>
              </div>
              <div class="select-container d-inline-flex">
                <a
                  id="button-{{sectionList.type}}"
                  class="section-type-btn btn-clear round-0 mr-2"
                  [ngClass]="{'active': i === 0 }" role="button"
                  *ngFor='let sectionList of tabs[selectedKey]?.sections; let i=index'
                  data-toggle="collapse"
                  [attr.data-target]="'#' +sectionList.type"
                  aria-expanded="true"
                  [attr.aria-controls]="sectionList.type"
                  (click)='handleCollapse($event)'
                >
                  {{sectionList.type}}
                </a>
              </div>
            </div>
            <div class="delete-btn-container">
              <!-- TODO capire se ci dovrà essere una description o meno -->
              <span class="delete-label"></span>
              <button class="btn text-error" (click)='removeStressYes(selectedKey, "tab")' [disabled]="keys.length === 1">{{getToolName(null, true)}}</button>
            </div>
          </ng-template>
          
          <button *ngIf="collapsed; else openCollapse" class="btn tab-configuration-collapse" (click)="openTabsCollapse()">
            <span class="btn-label">{{getTabConfiguration()}}</span>
            <span class="btn-link">Edit</span>
          </button>
        </div>

        <!-- SINGLE SECTION CONTENT -->

        <ng-container *ngFor='let sectionList of tabs[selectedKey]?.sections; let boxIndex = index'>
          <div
            class="section-list-wrapper mt-3"
            [id]="'input-section-container-'+boxIndex"
            [class.tab]='selectedKey'>
            <div class="section-header-container" *ngIf='selectedKey'>
              <span class="section-title">{{sectionList.name}}</span>
              <button
                *ngIf="sectionList.type === 'Stress_yes'"
                class="btn text-error"
                (click)='removeStressYes(sectionList.section_id, "section")'
              >
              Remove
            </button>
            </div>
            <div *ngIf='typeExecution === "GS"'>
              <div class="your-files">Your files</div>
              <p class="file-description">{{ tabsConfiguration?.tab_section_descrition }}</p>
            </div>
            <div
              id='{{sectionList.type}}'
              class="collapse section-list-container"
              [class.show]='boxIndex===0 || returnShowClass()'
              [class.p-3]='selectedKey'>
              <!-- Section input file to other tools -->
              <div class="section-container" *ngIf="typeExecution !== '17NL' && typeExecution !== '17L' && typeExecution !== 'SFR' && typeExecution !== 'RO'; else variantSectionList">
                <ng-container *ngFor='let section of sectionList.file_categories; let sectionIndex = index'>
                  <app-tool-section
                  *ngIf='!selectedKey && typeExecution !== "GS"'
                  [title]='section.name'
                  [description]='section.description'
                  icon
                  ></app-tool-section>

                  <app-input-uploader
                    [title]='selectedKey || typeExecution === "GS" ? section.name : "Add file"'
                    [id]='idExecution'
                    [selector]='sectionList.type + boxIndex + "-" + section.type'
                    (sendInfoToParent)='getFileFromInput($event, section, sectionList.section_id)'
                  ></app-input-uploader>
                  <span
                    *ngIf='typeExecution === "GS" && section.type === "mastro_rendiconto"'
                    class="nota">
                    You can upload multiple files at the same time
                  </span>
                  <ng-container *ngFor='let data of section.data, let i = index'>
                    <app-input-file-info
                      *ngIf='data'
                      [data]='data'
                      [selector]='section.type + "-" + i'
                      (delete)='deleteData($event, section)'
                      (sendSelectedConfigToParent)='getSelectedConfig($event)'
                    ></app-input-file-info>
                  </ng-container>
                </ng-container>
              </div>
              <!-- Section input file to IFRS17 non life, IFRS17 life, SFR and RO -->
              
              <ng-template #variantSectionList>
                <div class="section-container">
                  <app-tool-section
                    [title]='sectionList.name'
                    [description]='sectionList.description'
                    icon
                  ></app-tool-section>
                  <div class="input-list" *ngFor="let inputFile of sectionList?.file_categories">
                    <app-input-uploader
                      [title]='inputFile.name'
                      [id]='idExecution'
                      [selector]='sectionList.type + boxIndex + "-" + inputFile.type'
                      (sendInfoToParent)='getFileFromInput($event, inputFile, sectionList.section_id)'
                    ></app-input-uploader>
                    <ng-container *ngFor='let data of inputFile.data, let i = index'>
                      <app-input-file-info
                        *ngIf='data'
                        [data]='data'
                        [selector]='inputFile.type + "-" + i'
                        (delete)='deleteData($event, inputFile)'
                        (sendSelectedConfigToParent)='getSelectedConfig($event)'
                      ></app-input-file-info>
                    </ng-container>
                  </div>
                </div>
              </ng-template>
              <div
                class="section-container"
                [class.full-width]='config.component_type !== "select"'
                [class.stress-name-container]="config.type === 'Stress Name'"
                *ngFor="let config of sectionList.section_configurations; let configIndex = index">
                <div class="input-container" *ngIf="config.component_type === 'text'">
                  <p class="title">{{config.name}}</p>
                  <div class="form-group">
                    <input
                      type="text"
                      class="input-form-control"
                      [(ngModel)]="config.chosen_value"
                      placeholder='Insert value'
                      (blur)='addTagPromise(config.chosen_value, config.name, sectionList.section_id)'
                    >
                  </div>
                </div>
                <div
                  class="input-toggle"
                  [class.no-border]="typeExecution === '17NL'"
                  *ngIf="config.component_type === 'toggle'"
                  (click)='checkToggle(config, boxIndex, configIndex)'>
                  <p>{{config.name}}<p>
                  <div class="custom-control custom-switch">
                    <input
                      type="checkbox"
                      class="custom-control-input"
                      id="customSwitch-{{config.type}}"
                      [checked]='config.chosen_value'
                    >
                    <div
                      class="custom-control-label"
                      [class.active]="config.chosen_value"
                    ></div>
                  </div>
                </div>
                <div class="section-configurations-select gutter-top-32" *ngIf="config.component_type === 'select'">
                  <p class="title">{{config.name}}</p>
                  <ng-select
                    class='custom select-check-value'
                    [clearable]="false"
                    bindLabel="value"
                    bindValue="value"
                    [(ngModel)]='config.chosen_value'
                    [searchable]="false"
                    [items]='config.values'
                    placeholder='Select an option'
                    (change)='getSectionConfigValue($event, config)'
                  >
                  </ng-select>
                </div>
                <div class="section-configurations-select gutter-top-32" *ngIf="config.component_type === 'normal_select'">
                  <p class="title">{{config.name}}</p>
                  <ng-select
                    class='custom select-check-value'
                    [clearable]="false"
                    bindLabel="value"
                    bindValue="value"
                    [(ngModel)]='config.chosen_value'
                    [searchable]="false"
                    [items]='config.values'
                    placeholder='Select an option'
                    (change)='sendConfigurationDataToBE($event, config)'
                  >
                  </ng-select>
                </div>
                <div class="section-configurations-select gutter-top-32" *ngIf="config.component_type === 'normal_select_value_name'">
                  <p class="title">{{config.name}}</p>
                  <ng-select                    
                    class='custom select-check-value'
                    [loading] = 'config.loading'
                    [clearable]="true"
                    bindLabel="value.name"
                    bindValue="value.value"
                    [(ngModel)]='config.chosen_value'
                    [searchable]="true"
                    [items]='config.values'
                    placeholder='Select an option'
                    (change)='sendConfigurationDataValueNameToBE($event, config)'
                  >
                    <ng-template ng-loadingspinner-tmp><div class="spinner-border"></div></ng-template>
                  </ng-select>
                </div>

                <div class="px-3" *ngIf="config.component_type === 'toggle' && !config.chosen_value">
                  <ng-container *ngTemplateOutlet='sectionsConfigFiles'></ng-container>
                </div>
                <div class="pt-2" *ngIf="config.component_type === 'select' && config.chosen_value">
                  <ng-container *ngTemplateOutlet='sectionsConfigFiles'></ng-container>
                </div>
                <ng-template #sectionsConfigFiles>
                  <ng-container *ngFor="let granularityInput of config?.file_categories">
                    <app-input-uploader
                    [title]='granularityInput.name'
                    [id]='idExecution'
                    [selector]='config.type + boxIndex + "-" + granularityInput.type'
                    (sendInfoToParent)='getFileFromInput($event, granularityInput, config.section_id)'
                    ></app-input-uploader>
                    <ng-container *ngFor='let data of granularityInput.data, let i = index'>
                      <app-input-file-info
                        *ngIf='data'
                        [data]='data'
                        [selector]='granularityInput.type + "-" + i'
                        (delete)='deleteData($event, granularityInput)'
                        (sendSelectedConfigToParent)='getSelectedConfig($event)'
                      ></app-input-file-info>
                    </ng-container>
                  </ng-container>
                </ng-template>
              </div>
            </div>
          </div>
        </ng-container>
        <button *ngIf="typeExecution === 'LCA'" (click)='addStressTypeYes()' class="btn btn-stress-type">
          <span class="btn-link">Add Stress type - Yes</span>
          <i class="ic-add btn-icon"></i>
        </button>
      </ng-container>
    </div>
  </div>
  <app-execution-sidebar app-execution-sidebar 
  [execution]="execution" [subTools]="subTools"></app-execution-sidebar>
</div>
